enum UserRoles {
  AccountManager = 'am',
  Admin = 'admin',
  Staff = 'staff',
  Presenter = 'presenter',
  Client = 'client'
};

export default UserRoles;
